import styled from 'styled-components';

export const CardRow = styled.div`
    display: grid;
    grid-template-columns: 3.2rem 1fr max-content;
    column-gap: 1.6rem;
    align-items: baseline;
`;

export const CardNumber = styled.span`
    font-variant-numeric: tabular-nums;
`;

export const CardBody = styled.div`
    display: grid;
    row-gap: 0.4rem;
    justify-items: start;
`;

export const FieldLabel = styled.span`
    color: var(--gray-8);
    font-size: 1.3rem;
`;

export const RelatedFields = styled.div`
    display: grid;
    row-gap: 0.4rem;
    margin-top: 0.4rem;
    padding-left: 1.2rem;
    border-left: 2px solid var(--gray-4);
`;

export const CardsHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 0.8rem;
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-bottom: 1.2rem;
`;

export const SectionCards = styled.div`
    display: grid;
    row-gap: 1.6rem;
`;

export const CenteredSpin = styled.div`
    display: flex;
    justify-content: center;
    padding: 4rem 0;
`;
